import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionTypeExchangeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_534_10560)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.18738 11.7649H14.2045L11.5841 15.0402L12.4625 15.743L14.5955 13.0769C15.3813 12.0948 14.682 10.6399 13.4242 10.6399H3.18738V11.7649Z",
			fill: "black"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.8125 7.63986L3.79535 7.63986L6.41563 4.36451L5.53716 3.66173L3.40428 6.32781C2.61857 7.30996 3.31783 8.76486 4.57559 8.76486H14.8125V7.63986Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_534_10560",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white",
			transform: "translate(0 0.702209)"
		})
	}) })]
});
export default SvgTransactionTypeExchangeIcon;
